// utils/auth.js

export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

export const logout = (callback) => { // Added callback for consistency with your Home component logout
  localStorage.removeItem('token');
  localStorage.removeItem('role'); // Also remove the role on logout
  localStorage.removeItem('userId'); // Also remove the userId on logout
  if (callback) {
      callback();
  }
};

export const getUserRole = () => {
  return localStorage.getItem('role'); // Retrieve the stored role
};